import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { ROLES } from '@mdu-invoicing/shared';
import { AuthProvider } from './hooks/useAuth';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { RoleGuard } from './components/auth/RoleGuard';
import { AmountGuard } from './components/auth/AmountGuard';
import { UserManagerGuard } from './components/auth/UserManagerGuard';
import { AppLayout } from './components/layout/AppLayout';
import { Login } from './pages/auth/Login';
import { TwoFactor } from './pages/auth/TwoFactor';
import { Dashboard } from './pages/dashboard/Dashboard';
import { Eligibles } from './pages/eligibles/Eligibles';
import { Log } from './pages/log/Log';
import { Tariffs } from './pages/tariffs/Tariffs';
import { Pr } from './pages/pr/Pr';
import { Document } from './pages/document/Document';
import { AddMissed } from './pages/add/AddMissed';
import { Users } from './pages/users/Users';

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster richColors position="top-right" />
        <Routes>
          {/* Standalone pages (no auth required) */}
          <Route path="/login" element={<Login />} />
          <Route path="/2fa" element={<TwoFactor />} />

          {/* Protected app (shell + routed screens) */}
          <Route element={<ProtectedRoute />}>
            <Route element={<AppLayout />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/eligibles" element={<Eligibles />} />
              <Route
                path="/add"
                element={
                  <RoleGuard roles={[ROLES.PROVIDER]}>
                    <AddMissed />
                  </RoleGuard>
                }
              />
              <Route
                path="/document"
                element={
                  <RoleGuard roles={[ROLES.STAFF]}>
                    <Document />
                  </RoleGuard>
                }
              />
              <Route
                path="/log"
                element={
                  <RoleGuard roles={[ROLES.STAFF]}>
                    <Log />
                  </RoleGuard>
                }
              />
              <Route
                path="/pr"
                element={
                  <RoleGuard roles={[ROLES.STAFF]}>
                    <AmountGuard>
                      <Pr />
                    </AmountGuard>
                  </RoleGuard>
                }
              />
              <Route
                path="/tariffs"
                element={
                  <AmountGuard>
                    <Tariffs />
                  </AmountGuard>
                }
              />
              <Route
                path="/users"
                element={
                  <UserManagerGuard>
                    <Users />
                  </UserManagerGuard>
                }
              />
            </Route>
          </Route>

          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
